document.querySelectorAll(".popup-btn").forEach((popupButton) => {
  popupButton.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      // location.hash = "#" + e.target.dataset["for"];
      if (this.dataset["for"]) {
        document.querySelector(
          "." + this.dataset["for"] + " .popup"
        ).style.display = "block";
        document.querySelector(
          "." + this.dataset["for"] + ".popup-overlay"
        ).style.display = "block";
      }
    },
    false
  );
});
document.querySelectorAll(".popup-close").forEach((popupCloseButton) => {
  popupCloseButton.addEventListener(
    "click",
    function () {
      // location.hash = "";
      this.parentElement.style.display = "none";
      this.parentElement.parentElement.style.display = "none";
    },
    false
  );
});
document.querySelectorAll(".popup-overlay").forEach((popupCloseButton) => {
  popupCloseButton.addEventListener(
    "click",
    function () {
      // location.hash = "";
      this.style.display = "none";
    },
    false
  );
});
if (document.querySelector(".popup")) {
  document.querySelector("body").addEventListener(
    "click",
    function () {
      location.hash = "";
      document.querySelector(".popup").style.display = "none";
      document.querySelector(".popup-overlay").style.display = "none";
    },
    false
  );

  document.querySelector(".popup").addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
    },
    false
  );
}
